// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setCarePlanReportList,
  resetCarePlanReport
} from 'src/store/modules/reports/carePlanReport'

const initialState = []

export default handleActions(
  {
    [setCarePlanReportList](_, { payload: carePlanList }) {
      return carePlanList
    },

    [resetCarePlanReport]() {
      return initialState
    }
  },
  initialState
)
